import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// Create a theme instance.
const theme = createTheme({
	palette: {
		primary: {
			main: "#387cf6",
			dark: "#0558be",
			contrastText: "#fff",
		},
		secondary: {
			light: "#373b42",
			main: "#1c212d",
			dark: "#212121",
		},
		error: {
			main: red.A400,
		},
	},
});

export default theme;
